var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-snackbar',{attrs:{"timeout":_vm.tempo,"top":"top","color":_vm.cor},model:{value:(_vm.Mostrar),callback:function ($$v) {_vm.Mostrar=$$v},expression:"Mostrar"}},[_vm._v(" "+_vm._s(_vm.texto)+" "),_c('v-btn',{attrs:{"name":"fechar","text":""},on:{"click":_vm.fechar}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }